import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnDelete(props) {
  let index = useDataValue({
    context: 'charge_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'create_invoice',
    viewPath: props.viewPath,
  })

  return function onDelete() {
    change(next => {
      next.charges.splice(index, 1)
    })
  }
}
